import { useActiveSidebarLibrary } from '@/components/Sidebars/useActiveDirectory';
import { api } from '@/lib/trpc/react';
import type { RouterInputs } from '@unriddle/api';
import { useCallback } from 'react';
import { useWorkspaceActions } from './useWorkspace';

const useNewNote = (
  mutationOptions?: Parameters<typeof api.chatbot.createNote.useMutation>[0],
) => {
  const { addChatbot } = useWorkspaceActions();

  const { currentPath } = useActiveSidebarLibrary();

  const {
    mutateAsync: createNote,
    isPending,
    error,
  } = api.chatbot.createNote.useMutation({
    ...mutationOptions,
    onSuccess: (data, variables, context) => {
      if (!data) return;
      addChatbot({
        ...data,
        isIndexed: false,
        ingestionStatus: null,
        authors: data.authors as string[],
      });
      mutationOptions?.onSuccess?.(data, variables, context);
    },
  });

  const wrapCreateChatbot = useCallback(
    (chatbot: RouterInputs['chatbot']['createNote']) => {
      let groupId: string | undefined;
      let teamId: string | undefined;
      if (currentPath?.type === 'GROUP') groupId = currentPath.id;
      if (currentPath?.teamId) teamId = currentPath.teamId;

      return createNote({
        ...chatbot,
        groupId,
        teamId,
      });
    },
    [currentPath],
  );
  return { createNote: wrapCreateChatbot, isPending, error };
};

export default useNewNote;
